import React, { useState } from "react";
import "./catalogue.css";
import API_ROUTES from "./config/apiConfig";

const CatalogueModal = ({ show, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  if (!show) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.message) {
      setError("Name, Email aur Message required hain.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(API_ROUTES.CREATE_ENQUIRY, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          address: formData.address,
          message: formData.message,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccess(true);
        setFormData({ name: "", email: "", phone: "", address: "", message: "" });
        setTimeout(() => {
          setSuccess(false);
          onClose();
        }, 2500);
      } else {
        setError(data.message || "Something went wrong.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">

        {/* LEFT SIDE */}
        <div className="modal-left">
          <div className="left-top">
            <img className="logo2" src="/images/logo.png" alt="" />
            <h2 className="mt-4">THE BIG <br />FURNITURE</h2>
            <h1 className="sale">SALE</h1>
          </div>
          <div className="left-bottom">
            <div className="bottom-content">
              <img src="/images/3d.png" alt="furniture" className="left-img" />
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="modal-right">
          <button className="close-btn" onClick={onClose}>✖</button>
          <h2 className="pb-4">Get the Catalogue</h2>

          {/* Success Message */}
          {success && (
            <div className="alert-success-box">
              ✅ Enquiry submitted! We will contact you shortly.
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div className="alert-error-box">
              ❌ {error}
            </div>
          )}

          {!success && (
            <>
              <input
                type="text"
                name="name"
                placeholder="Name *"
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="text"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
              />
              <input
                type="text"
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
              />
              <textarea
                name="message"
                placeholder="Message *"
                value={formData.message}
                onChange={handleChange}
              />

              <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "ENQUIRE NOW"}
              </button>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default CatalogueModal;